/**
 * cartLineTotals — Totales puros de una línea del carrito (lista).
 *
 * QUÉ HACE: Extrae de `discountAttribution` las funciones que solo dependen
 *   del ítem, para que componentes compartidos del POS las usen sin importar
 *   el motor de descuentos de Caja.
 * QUÉ EXPORTA: getLineUnitLista, getLineListaTotal.
 * QUÉ NO DEBE HACER: No conoce React, descuentos globales ni tickets.
 */
import type { CartItem } from "@/types";

const clampMoney = (value: number): number => Math.max(0, Math.round(value));

/** Precio unitario de lista de la línea (peso → por kg). */
export const getLineUnitLista = (item: CartItem): number => {
  if (item.peso && item.peso > 0) {
    return Math.round(item.precioPorKilo || item.precio || 0);
  }
  return Math.round(item.precioLista ?? item.precio ?? 0);
};

/** Total de lista de la línea (base para el «Subtotal (precio lista)»). */
export const getLineListaTotal = (item: CartItem): number => {
  const qty = Math.max(1, item.quantity || 1);
  if (item.peso && item.peso > 0) {
    return clampMoney(getLineUnitLista(item) * (item.peso || 0));
  }
  return clampMoney(getLineUnitLista(item) * qty);
};
